import {
    LIST_UNITS,
    LIST_UNITS_SUCCESS,
    LIST_UNITS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    error: null,
    loading: false,
    units: null
}

export default function jurisdictionsReducer(state = initialState, action) {
    switch(action.type){
        case LIST_UNITS:
            return {
                ...state,
                loading: true
            }
        case LIST_UNITS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_UNITS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                units: action.payload
            }
        default:
            return state;
    }
}